// JS to embed product cards/collection grids inside blog post content via placeholders.
// Author usage examples (within blog rich-text editor):
//   <span class="blog-embed--product" data-product-handle="my-product-handle"></span>
//   <span class="blog-embed--collection" data-collection-handle="summer" data-limit="4"></span>
// The script fetches the JSON endpoints and injects rendered HTML using existing 'card-product' snippet.

(function() {
  function fetchJSON(url) {
    return fetch(url)
      .then(r=>{if(!r.ok) throw new Error('404'); return r.text();})
      .then(text=>{try{return JSON.parse(text);}catch(e){throw new Error('invalid-json');}});
  }

  function buildProductCardHTML(product) {
    // Minimal card markup consistent with 'card-product' structure
    // Uses product.first_available_variant for price display
    const price = (product.price / 100).toFixed(2);
    return `
      <div class="card-wrapper">
        <a href="${product.url}" class="full-unstyled-link">
          <div class="media" style="padding-bottom:100%;">
            <img src="${product.featured_image}" alt="${product.title}" loading="lazy">
          </div>
          <div class="card__content">
            <h3 class="card__heading h5">${product.title}</h3>
            <div class="price">$${price}</div>
          </div>
        </a>
      </div>`;
  }

  function buildProductSchema(product){
    return {
      "@context":"https://schema.org/",
      "@type":"Product",
      "name":product.title,
      "url":product.url,
      "image":product.featured_image,
      "description":product.description || product.title,
      "sku":product.variants[0] ? product.variants[0].sku : undefined,
      "offers":{
        "@type":"Offer",
        "priceCurrency":Shopify.currency.active || 'USD',
        "price":(product.price/100).toFixed(2),
        "availability":"https://schema.org/OnlineOnly"
      }
    };
  }

  function injectSchema(obj){
    const script=document.createElement('script');
    script.type='application/ld+json';
    script.textContent=JSON.stringify(obj);
    document.head.appendChild(script);
  }

  function fetchCardHtml(handle){
    return fetch(`/products/${encodeURIComponent(handle)}?view=card-product-inline`).then(r=>r.text());
  }

  function renderProductPlaceholder(el){
    const handle=el.dataset.productHandle;
    if(!handle) return;
    // fetch product data and card concurrently
    Promise.all([
      fetchJSON(`/products/${encodeURIComponent(handle)}.js`),
      fetchCardHtml(handle)
    ]).then(([product,html])=>{
      el.outerHTML=`<div class="article-product-card grid__item">${html}</div>`;
      injectSchema(buildProductSchema(product));
    }).catch(()=>{el.remove();});
  }

  async function renderCollectionPlaceholder(el) {
    const handle = el.dataset.collectionHandle;
    if (!handle) return;
    const limit = parseInt(el.dataset.limit) || 4;

    try {
      // Fetch products
      const prodData = await fetchJSON(`/collections/${encodeURIComponent(handle)}/products.json?limit=${limit}`);
      const products = prodData.products ? prodData.products.slice(0, limit) : [];

      // Build cards
      const cardHtmlArr = await Promise.all(products.map(p => fetchCardHtml(p.handle)));
      const cardsHtml = cardHtmlArr.map(h => `<div class="grid__item">${h}</div>`).join('');

      // Attempt to fetch collection title
      let title = handle.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
      try {
        const collMeta = await fetchJSON(`/collections/${encodeURIComponent(handle)}.js`);
        if (collMeta && collMeta.title) title = collMeta.title;
      } catch(e){ /* fallback uses derived title */ }

      const headingHtml = `<h3 style="text-align:center;margin-bottom:1rem;color:#41a5da;">Shop ${title}</h3>`;
      const gridHtml = `<div class="article-collection-list grid grid--4-col-desktop grid--2-col-tablet grid--2-col-tablet-down">${cardsHtml}</div>`;
      const buttonHtml = `<div style="text-align:center;margin-top:1rem;color:"><a href="/collections/${handle}" class="button button--primary">Shop All ${title}</a></div>`;

      el.outerHTML = `<div class="article-collection-list-wrapper" style="margin:3rem 0;">${headingHtml}${gridHtml}${buttonHtml}</div>`;

      // Structured data
      const itemList = {
        "@context":"https://schema.org/",
        "@type":"ItemList",
        "itemListElement": products.map((p,i)=>({"@type":"ListItem","position":i+1,"url":p.url}))
      };
      injectSchema(itemList);
      products.forEach(p=>injectSchema(buildProductSchema(p)));
    } catch(err){
      el.remove();
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.blog-embed--product').forEach(renderProductPlaceholder);
    document.querySelectorAll('.blog-embed--collection').forEach(renderCollectionPlaceholder);
  });
})(); 